<template>

	<div class="form-group">

		<label for="month">{{ label }}</label>

		<div :class="{ 'input-group': group }">

			<div class="input-group-addon" v-if="group">
				<i class="fa fa-calendar-o" aria-hidden="true"></i>
			</div>

			<select id="month" class="form-control" v-model="month" :required="required" :disabled="disabled" @change="changed">
				<option value="" selected v-translate>Selecione um mês</option>
				<option v-for="(month, index) in ENUM.Month" :value="index">{{ month }}</option>
			</select>

		</div>

	</div>

</template>


<script>

	import Month from './';
	export default Month;

</script>



// WEBPACK FOOTER //
// main.vue?5bfca5ac